import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      background: theme.colors.blue[1],
      padding: `${rem(24)} 0`,
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
    },
    card: {
      boxShadow: theme.shadows.xs,
    },
  }
})
